module.exports = __webpack_public_path__ + "static/media/0.beginning_loop.f1dc83b6.mp4";